import { getLikedSnapsCount as getLikedSnapsCountApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';
import {
  type GetLikedSnapsCountServiceRequest,
  GetLikedSnapsCountServiceRequestSchema,
  type LikedSnapsCountMap,
  LikedSnapsCountMapSchema,
} from './get-liked-snaps-count.dto';

export const getLikedSnapsCountService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetLikedSnapsCountServiceRequestSchema),
    async (request: GetLikedSnapsCountServiceRequest): Promise<LikedSnapsCountMap> => {
      if (request.ids.length === 0) {
        return {};
      }

      const apiResponse = await getLikedSnapsCountApi({ ids: request.ids });
      const entries = apiResponse.data ?? {};

      return Object.fromEntries(
        Object.entries(entries).map(([snapId, entry]) => [
          snapId,
          {
            isLiked: entry.isExists,
            likeCount: entry.likeCount ?? 0,
          },
        ]),
      );
    },
    validateServiceResponse(LikedSnapsCountMapSchema),
  ),
);
